import React from "react";
import Overview from "./Overview";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import GroupAdminSidebar from "../../Layout/GroupAdminSidebar";
import { useUser } from "../../context/AuthContext";
import Dashboard from "../Environment/Dashboard";
import TrialUserSidebar from "../../Layout/TrailUserSidebar";

const Index = () => {
  const { user } = useUser();
  return (
    <MainDashboardLayout
      sidebar={
        user?.groupManager ? (
          <GroupAdminSidebar />
        ) : user?.isTrialUser ? (
          <TrialUserSidebar />
        ) : (
          <MainSidebar />
        )
      }
    >
      {user?.companyAdmin || user?.groupManager ? (
        <Overview />
      ) : (
        <Dashboard showCompany={true} />
      )}
    </MainDashboardLayout>
  );
};

export default Index;
